import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, toast, pricingHelpers, CurrencyContext, FormatCurrency, constants } from 'day8-ui';
import { InstalmentsBar } from 'day8-react/build/new-components';
import {
  PaymentBridge,
  orderToInstalmentsHelpers
} from 'day8-react';
import { getCardChargesExist } from '../../../../helpers/pricing';
import { getExtraBookingTermsUrl } from '../../../../helpers/legalDocumentUrls';
import { useToolipModal } from '../../../../context/TooltipModalContext';

const { BUSINESS_PAYMENT_TYPE } = constants;
const RecurringPaymentsOption = ({
  booking,
  onError,
  createPayment,
  checkPaymentInfo,
  onPaymentSuccess,
  email,
  girls,
  guys,
  isYachtsAndFriends,
  companyId,
  setActivePaymentOption,
  activePaymentOption,
  hasPromoCodeApplied
}) => {
  const { openTooltipModal } = useToolipModal();
  const currencyContext = useContext(CurrencyContext);
  const order = booking.mainOrder;
  const items = orderToInstalmentsHelpers.generateItemsFromScheduledPayments(order, false, booking.scheduledPayments);
  const cardChargesExist = getCardChargesExist();
  const amount = order.orderDeadlines[0].amount;
  const amountText = (
    <FormatCurrency
      amount={amount / 100}
      baseCurrency={order.currency}
      round={false}
    />
  );

  return (
    <div className={`dui-pt-8`}>
      <InstalmentsBar items={items} currency={order.currency} />
      <p className="dui-text-sm dui-mt-8">This will set up a monthly direct from the lead bookers card. See FAQ&#39;s for more details <a className='dui-inline-block dui-font-semibold' href="https://help.theyachtweek.com/en/?q=payments+cancellation" target="_blank" rel="noopener noreferrer">Find out more</a> </p>
      {cardChargesExist && (
        <p className='dui-inline-block dui-mt-8'>Want to skip the card fees? <Button className='!dui-inline-block' buttonType='LINK_UNDERLINE' buttonSize='MEDIUM' onClick={() => setActivePaymentOption('payFull')}>Pay in full</Button></p>
      )}
      <div className={`dui-pt-8`}>
        <PaymentBridge
          amountString={amountText}
          registeredAmount={amount}
          paidAmount={pricingHelpers.convertPrice(
            amount,
            order.currency,
            currencyContext.currency,
            currencyContext.rates
          )}
          onError={onError}
          createPayment={createPayment}
          checkPaymentInfo={checkPaymentInfo}
          onPaymentSuccess={onPaymentSuccess}
          orderId={order.id}
          currency={currencyContext.currency}
          email={email}
          bookingId={booking.id}
          visa
          amex={true}
          girls={girls}
          guys={guys}
          minAge={booking?.destination?.ageLimit || 20}
          mastercard
          product={isYachtsAndFriends ? 'Yachts and Friends' : 'Yacht Week'}
          baseUrl="https://www.theyachtweek.com"
          companyId={companyId}
          weekTerms={getExtraBookingTermsUrl(booking)}
          destinationId={booking?.destination?.id}
          scheduledPayments={booking.scheduledPayments}
          activePaymentOption={activePaymentOption}
          travelInsuranceCheckBox
          hasPromoCodeApplied={hasPromoCodeApplied}
          openTooltipModal={openTooltipModal}
          toast={toast}
          departureDate={booking?.week?.guestBeginDate}
          returnDate={booking?.week?.guestEndDate}
          businessPaymentType={BUSINESS_PAYMENT_TYPE.DEPOSIT}
          disableWalletPayments={false}
          disableApplePay={isYachtsAndFriends}
        />
      </div>
    </div>
  );
};

RecurringPaymentsOption.propTypes = {
  booking: PropTypes.object,
  createPayment: PropTypes.func.isRequired,
  checkPaymentInfo: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  isYachtsAndFriends: PropTypes.bool,
  amount: PropTypes.number.isRequired,
  amountText: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  girls: PropTypes.number.isRequired,
  guys: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  setActivePaymentOption: PropTypes.func.isRequired,
  activePaymentOption: PropTypes.string.isRequired,
  cardChargesExist: PropTypes.bool,
  hasPromoCodeApplied: PropTypes.bool
};

export default RecurringPaymentsOption;
